import React from 'react';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';

interface StatCardProps {
  icon: React.ReactNode;
  label: string;
  value: string | number;
  change?: number;
  changeLabel?: string;
  prefix?: string;
  suffix?: string;
  loading?: boolean;
  accent?: boolean;
  alert?: boolean;
}

const StatCard: React.FC<StatCardProps> = ({
  icon,
  label,
  value,
  change,
  changeLabel,
  prefix = '',
  suffix = '',
  loading = false,
  accent = false,
  alert = false,
}) => {
  if (loading) {
    return (
      <div className={`cc-stat cc-loading ${accent ? 'cc-stat--accent' : ''} ${alert ? 'cc-stat--alert' : ''}`}>
        <div className="cc-stat__icon-wrap">
          <div className="cc-loading-shimmer" style={{ width: 28, height: 28, borderRadius: 8 }} />
        </div>
        <div className="cc-loading-shimmer" style={{ width: '60%', height: 22, borderRadius: 4, marginTop: 8 }} />
        <div className="cc-loading-shimmer" style={{ width: '40%', height: 11, borderRadius: 4, marginTop: 6 }} />
      </div>
    );
  }

  return (
    <div className={`cc-stat ${accent ? 'cc-stat--accent' : ''} ${alert ? 'cc-stat--alert' : ''}`}>
      {accent && <div className="cc-stat__glow" />}
      <div className="cc-stat__header">
        <div className={`cc-stat__icon ${alert ? 'cc-stat__icon--alert' : ''}`}>
          {icon}
        </div>
        {change !== undefined && (
          <div className={`cc-stat__change ${change >= 0 ? 'cc-stat__change--up' : 'cc-stat__change--down'}`}>
            {change >= 0 ? <ArrowUpRight size={12} /> : <ArrowDownRight size={12} />}
            {Math.abs(change)}%
          </div>
        )}
      </div>
      <div className="cc-stat__value">
        {prefix}{value}{suffix}
      </div>
      <div className="cc-stat__label">{label}</div>
      {changeLabel && <div className="cc-stat__change-label">{changeLabel}</div>}
    </div>
  );
};

export default StatCard;
